import { render, staticRenderFns } from "./BaseFileDrag.vue?vue&type=template&id=6607f8bc&scoped=true"
import script from "./BaseFileDrag.vue?vue&type=script&lang=js"
export * from "./BaseFileDrag.vue?vue&type=script&lang=js"
import style0 from "./BaseFileDrag.vue?vue&type=style&index=0&id=6607f8bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6607f8bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
